
import vue from 'vue'
import wxlList from './src'
// 创建vue组件实例
const LIST = vue.extend(wxlList)
const ListWrap = document.createElement('div')
ListWrap.className = 'list-wrap'
document.body.appendChild(ListWrap)
const List = {
    dom: null,
    running: false,
    show: ({
        title,
        ismulpicker,
        list,
        displaykey,
        memokey,
        cancelonclickmask,
        success,
        cancel,
        onfilter
    }) => {
        if (List.dom !== null && List.running === true) {
            return
        }
        List.running = true
        List.dom = new LIST({
            el: document.createElement('div'),
            data() {
                return {
                    show: false,
                    title: title,
                    ismulpicker: ismulpicker || false,
                    itemsource: list,
                    displaykey: displaykey || 'name',
                    memokey: memokey,
                    cancelonclickmask: cancelonclickmask,
                    onfilter: onfilter
                }
            },
            methods: {
                clicksure: function() {
                    this.show = false
                    setTimeout(() => {
                        if (typeof sure === 'function') {
                            success()
                        }
                    }, 200)
                },
                cancel: function() {
                    this.show = false
                    setTimeout(() => {
                        if (typeof cancel === 'function') {
                            List.running = false
                            cancel()
                        }
                    }, 200)
                },
                clickitem: function(item) {
                    if (typeof success === 'function') {
                        success(item)
                    }
                    this.show = false
                }
            },
            watch: {
                show: function(nv) {
                    if (nv === false) {
                        List.running = false
                    }
                }
            },
            created() {
            },
            mounted() {
                this.show = true
            },
            destroyed() {
            },
            beforeDestroy() {
            }
        })
        ListWrap.appendChild(List.dom.$el)
    },
    isshow() {
        return List.running
    },
    hide() {
        if (this.dom !== null) {
            this.dom.$data.show = false
        }
    }
}
const plugin = {}
plugin.install = function(Vue) {
  Vue.prototype.__list = List
}
export { wxlList }// 局部注册时可以直接 import
export default plugin// 全局注册时 Vue.use